import React, { useEffect } from 'react';

const Ia = ({ show, email }) => {
  useEffect(() => {
    // Chargement du token signé
    fetch('/api/connect/extauthtoken')
    .then(response => {
        if (response.status !== 200) {
            console.error('return KO from extauthtoken')
            return response.text();
        }
        return response.json();
    })
    .then(content => {
        const signedToken = content.chainlitToken;
        // Charger le script Chainlit
        const scriptChainlit = document.createElement('script');
        scriptChainlit.src = 'https://mecatheque.ai.cetim.fr/copilot/index.js';
        scriptChainlit.async = true;
        document.body.appendChild(scriptChainlit);

        scriptChainlit.onload = () => {
            // console.log('Script Chainlit chargé.');
            // Ajouter l'écouteur pour chainlit-call-fn
            window.addEventListener('chainlit-call-fn', (e) => {
                const { name, args, callback } = e.detail;
                // console.log(`Fonction appelée : ${name}, avec les arguments :`, args);
                callback(`You sent: ${args.msg}`);
            });

            if (!show) return null;
            // Initialiser le widget Chainlit
            window.mountChainlitWidget({
                chainlitServer: "https://mecatheque.ai.cetim.fr",
                accessToken: signedToken,
                theme: "light",
                button: {
                style: {
                    bgcolor: "#001e50",
                    bgcolorHover: "#ef3346"
                },
                imageUrl: "./images/picto-ia.png"
                },
            });
        };

        scriptChainlit.onerror = () => {
        console.error('Échec du chargement du script Chainlit.');
        }
    });
  }, [show]); 

  if (!show) return null;
  
  return (
    <div>
      {show && (
        <div id="chatbutton" style={{display: 'none'}}>
          <button>insert button here</button>
        </div>
      )}
    </div>
  );
};

export default Ia;
